import SpecificationInterface from './specification-interface';

class DisabledPlayerIfGameInactiveSpecification implements SpecificationInterface {
    isSatisfiedBy(params: object): boolean {
        // @ts-ignore
        const {sportConfig, games, player} = params;

        return sportConfig !== undefined && sportConfig.isSportMlb() && games.isPlayerGameInactive(player);
    }
}

export default new DisabledPlayerIfGameInactiveSpecification();
